import React from 'react';
import SimpleDialog from "./Dialog.jsx";
export default function FormDialog() {
  return (
    <SimpleDialog/>
  );
}

